import { BaseRequest } from "./baseRequest";

export class ConfAttachmentRequest extends BaseRequest {
  confSessionId?: number;
  configurationId?: number;
  attachmentId?: number;
}